export default __webpack_public_path__ + "static/media/4Klein.fd264576.jpg";